import { Box, Button, Skeleton } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import styles from "./Tasks.module.css";
import CompletedCard from "./CompletedCard/CompletedCard";
import { useNavigate } from "react-router-dom";
import TaskKanbanHeader from "./TaskKanbanHeader/TaskKanbanHeader";
import High from "./Assets/High.svg";
import Normal from "./Assets/Normal.svg";
import Low from "./Assets/Low.svg";
import Urgent from "./Assets/Urgent.svg";
import moment from "moment";
import { useSelector } from "react-redux";
import { useAuthUser } from "react-auth-kit";
import dayjs from "dayjs";
import DateRangePicker from "../../../../components/DateRangePicker/DateRangePicker";
import getAccessStatus, {
  checkSubDomainAccess,
  getSubDomainAccessStatus,
} from "../../../../components/RolePermissionAccess/RolePermissionAccess";
import { resetCreatePaymentSuccessForTask } from "../../Nurture/service/nurtureSlice";
import { useDispatch } from "react-redux";
import { setToastNotification } from "../../../../components/ToastNotification/service/toastNotificationSlice";
import getTeamMember from "../../../../components/CommonFunctions/CommonFunctions";
import { GetTaskBoard } from "../service/tasks.request";
import InfiniteScroll from "react-infinite-scroll-component";
import { getDescriptionWithMentionedNames } from "../../../../components/CommonFunctions/CommonFunctions";
import {
  setTrigger,
  toggleTaskTrigger,
} from "../../Main/service/taskBoardUpdationSlice";
import { openLeadExpandModal } from "../../../../components/LeadPopup/hooks/useLeadCard";
import Remainder from "../../../../assets/images/remainder.svg";
import RemainderPopup from "./RemainderPopup";
import { resetSendRemainders } from "../service/tasksSlice";

interface Task {
  id: number;
  title: string;
  state: string;
  date: string;
  taskType: string;
  leadName: string;
  priority: string;
}

interface TaskKanbanProps {
  tasks: Task[];
}

interface CheckedPriorities {
  priority: string;
}
interface CheckedTypes {
  type: string;
}

type Data = {
  instituteId: string;
  startDate: any;
  endDate: any;
  limit: number;
  userId?: any;
  branchId?: any;
  lanesToFetch?: {
    status: string;
    searchAfter?: string;
    // lastEvaluatedKey: string;
    // lastEvaluatedSortKey: string;
  }[];
};

export default function TasksKanban(props: any) {
  const {
    tasks,
    UpdateTaskStatus,
    tasksByAssignee,
    GetTasksBoard,
    tasksTypes,
    taskStatusUpdateSuccess,
    GetLeadListByInstituteAndContact,
    CreateTask,
    taskBoardloading,
    SendRemainders,
    sendRemaindersLoading,
    sendRemaindersSuccess,
    GetTaskCount,
    taskCountLength,
  } = props;

  const auth = useAuthUser();
  const authUser = auth();
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const [taskItems, setTaskItems] = useState<any>();
  const [hasMoreData, setHasMoreData] = useState<boolean>(true);
  const [isOpen, setIsOpen] = useState(false);
  const [filterStartDate, setFilterStartDate] = useState<any>(new Date());
  const [filterEndDate, setFilterEndDate] = useState<any>(null);
  const [textForReminder, setTextForReminder] = useState("");

  const { userById } = useSelector((state: any) => state.userDetails);
  const hasAllBranchAccess = getSubDomainAccessStatus(
    "GLOBAL_PERMISSIONS",
    "BRANCH_ACCESS",
    "ALL_BRANCHES",
    userById?.rolePermission
  );

  const hasAllTaskAccess = getAccessStatus(
    "TASKS",
    "ALL_OTHER_USERS'_TASK",
    userById?.rolePermission
  );

  const hasLeadCardPermission = checkSubDomainAccess(
    "NURTURE_BOARD",
    "LEAD_CARD",
    userById?.rolePermission
  );

  const employees = useSelector((state: any) => state.staff.staffList);

  const {
    editTaskSuccess,
    createTaskSuccess,
    deleteTaskSuccess,
    leadUpdateSuccess,
  } = useSelector((state: any) => state.nurture);

  const [selectedDate, setSelectedDate] = React.useState<number | null>(
    dayjs().unix() * 1000
  );
  const [selectedTeamMember, setSelectedTeamMember] = React.useState<any>([]);
  const [draggedLead, setdraggedLead] = useState<string>("");
  const [draggedLeadTaskType, setdraggedLeadTaskType] = useState<string>("");
  const [draggedTask, setdraggedTask] = useState<any>("");
  const [dropZoneActive, setDropZoneActive] = useState<boolean>(false);

  const [draggedColumn, setdraggedColumn] = useState<string>("");
  const [newDate, setNewDate] = useState<any>(dayjs());
  const [stateName, setStateName] = useState<string>("");
  const [cardType, setCardType] = useState<string>("");
  const [taskId, setTaskId] = useState<string>("");

  const filteredTasks =
    tasks && taskItems?.filter((task: any) => task?.stateName !== "COMPLETED");

  const completedTasks =
    tasks && taskItems?.find((task: any) => task.stateName === "COMPLETED");

  const [isDragging, setIsDragging] = useState(false);

  const allTasksEmpty =
    tasks &&
    filteredTasks?.every(
      (item: any) => item?.tasks?.data && item?.tasks?.data?.length === 0
    );

  const completedTasksEmpty: boolean = completedTasks
    ? completedTasks?.tasks?.data?.length === 0
    : false;

  const handleDragStart = React.useCallback(
    (
      event: React.DragEvent<HTMLDivElement>,
      columnStatus: any,
      taskId: any,
      taskType: string,
      task: string
    ) => {
      setdraggedLead(taskId);
      setdraggedLeadTaskType(taskType);
      setdraggedTask(task);
      event.dataTransfer.setData("columnStatus", columnStatus.toString());
      event.dataTransfer.setData("taskId", taskId.toString());
      setdraggedColumn(columnStatus);

      setIsDragging(true);
      event.currentTarget.style.zIndex = "999";
      // setDropZoneActive(true);
    },
    [setdraggedLead]
  );

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.currentTarget.classList.add(styles.dragoverColumn);
    setDropZoneActive(true);
  };

  const handleCompletedDrop = (event: React.DragEvent<HTMLDivElement>) => {
    if (draggedLeadTaskType === "DEMO") {
      navigate(`/app/Tasks/DemoTaskDetails/${draggedLead}`);
    } else {
      const draggedColumnStatus = draggedColumn;
      if (draggedColumnStatus !== "COMPLETED") {
        UpdateTaskStatus({
          taskId: draggedLead,
          taskStatus: "COMPLETED",
          updatedById: authUser?.institute[0]?.id,
          updatedByName: authUser?.firstName + " " + authUser?.lastName,
          taskType: draggedLeadTaskType,
          instituteId: authUser?.institute[0]?.instituteId,
        });
      }
    }
    setDropZoneActive(false);
    event.currentTarget.classList.remove(styles.dragoverColumn);
    setIsDragging(false);
    setdraggedColumn("");
  };

  const handleDragLeave = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.currentTarget.classList.remove(styles.dragoverColumn);
    setIsDragging(false);
    setDropZoneActive(false);
  };

  const handleDrop = (
    event: React.DragEvent<HTMLDivElement>,
    columnStatus: any,
    stateName: any
  ) => {
    const draggedColumnStatus = draggedColumn;

    stateName = stateName.toUpperCase().replace(" ", "_");
    setDropZoneActive(false);
    if (draggedLeadTaskType === "DEMO") {
      const demoStudentUpdate = draggedTask?.demoData?.map((item: any) => {
        return {
          demoStudentId: item.id,
          status: item?.status,
        };
      });
      if (draggedColumnStatus !== columnStatus) {
        UpdateTaskStatus({
          taskId: draggedLead,
          taskStatus: stateName,
          updatedById: authUser?.institute[0]?.id,
          updatedByName: authUser?.firstName + " " + authUser?.firstName,
          taskType: draggedLeadTaskType,
          instituteId: authUser?.institute[0]?.instituteId,
          demoStudentUpdate: demoStudentUpdate,
        });
      }
    } else {
      if (draggedColumnStatus !== columnStatus) {
        UpdateTaskStatus({
          taskId: draggedLead,
          taskStatus: stateName,
          updatedById: authUser?.institute[0]?.id,
          updatedByName: authUser?.firstName + " " + authUser?.firstName,
          taskType: draggedLeadTaskType,
          instituteId: authUser?.institute[0]?.instituteId,
        });
      }
    }

    event.currentTarget.classList.remove(styles.dragoverColumn);
    setIsDragging(false);
    setdraggedColumn("");
  };

  const [leadSearchTerm, setLeadSearchTerm] = React.useState("");

  const handleLeadSearch = (event: any) => {
    setLeadSearchTerm(event.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);

    const taskStartDate = urlSearchParams.get("taskStartDate");
    const taskEndDate = urlSearchParams.get("taskEndDate");
    const selectedUsersParam = urlSearchParams.get("selectedUsers");
    if (rangeStartDate && authUser && authUser.institute) {
      if (taskStartDate && taskEndDate) {
        taskBoardApiCall(
          authUser?.institute[0]?.instituteDetails?.id,
          taskStartDate,
          taskEndDate,
          selectedUsersParam ? selectedUsersParam : "",
          event.target.value
        );
        taskCountCall(
          authUser?.institute[0]?.instituteDetails?.id,
          taskStartDate,
          taskEndDate,
          selectedUsersParam ? selectedUsersParam : "",
          event.target.value
        );
      } else {
        const selectedDateFirstMinute =
          moment(rangeStartDate).startOf("day").unix() * 1000;

        const selectedDateLastMinute =
          moment(rangeStartDate).endOf("day").unix() * 1000;

        taskBoardApiCall(
          authUser?.institute[0]?.instituteDetails?.id,
          selectedDateFirstMinute,
          selectedDateLastMinute,
          selectedUsersParam ? selectedUsersParam : "",
          event.target.value
        );
        taskCountCall(
          authUser?.institute[0]?.instituteDetails?.id,
          selectedDateFirstMinute,
          selectedDateLastMinute,
          selectedUsersParam ? selectedUsersParam : "",
          event.target.value
        );
      }
    }
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("taskLeadSearch", event.target.value);
    const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
    window.history.pushState({}, "", newUrl);
  };

  function getFormattedDate(date: any) {
    return moment(date).format("DD MMM YYYY, hh:mm A");
  }

  const [filterCheckedPriorities, setFilterCheckedPriorities] = useState<
    CheckedPriorities[]
  >([]);

  const [filterCheckedTypes, setFilterCheckedTypes] = useState<CheckedTypes[]>(
    []
  );

  const filteredValue = (
    <>
      {filterCheckedPriorities?.length > 0 &&
        filterCheckedPriorities?.map((item) => (
          <div key={item.priority} className="filteredDiv">
            {item.priority.toLowerCase()}
          </div>
        ))}

      {filterCheckedTypes?.length > 0 &&
        filterCheckedTypes?.map((item) => (
          <div key={item.type} className="filteredDiv">
            {item.type?.toLowerCase()}
          </div>
        ))}
    </>
  );

  const handleFilterTasks = React.useCallback(
    (
      prioritiesArray: any,
      typesArray: any,
      filterStartDates: any,
      filterEndDates: any
    ) => {
      setFilterCheckedPriorities(prioritiesArray);
      setFilterCheckedTypes(typesArray);
      const urlSearchParams = new URLSearchParams(window.location.search);

      const taskStartDate = urlSearchParams.get("taskStartDate");
      const taskEndDate = urlSearchParams.get("taskEndDate");
      const selectedUsersParam = urlSearchParams.get("selectedUsers");

      const selectedDateFirstMinuteForFilter =
        moment(filterStartDates).startOf("day").unix() * 1000;
      const selectedStartDateLastMinuteForFilter =
        moment(filterStartDates).endOf("day").unix() * 1000;

      const selectedDateLastMinuteForFilter =
        moment(filterEndDates).endOf("day").unix() * 1000;

      if (rangeStartDate && authUser && authUser.institute) {
        if (taskStartDate && taskEndDate) {
          taskBoardApiCall(
            authUser?.institute[0]?.instituteDetails?.id,
            taskStartDate,
            taskEndDate,
            selectedUsersParam
              ? selectedUsersParam.split(",").filter(Boolean)
              : "",
            "",
            prioritiesArray,
            typesArray,
            Number(selectedDateFirstMinuteForFilter),
            Number(selectedDateLastMinuteForFilter)
          );
          taskCountCall(
            authUser?.institute[0]?.instituteDetails?.id,
            taskStartDate,
            taskEndDate,
            selectedUsersParam
              ? selectedUsersParam.split(",").filter(Boolean)
              : "",
            "",
            prioritiesArray,
            typesArray,
            Number(selectedDateFirstMinuteForFilter),
            Number(selectedDateLastMinuteForFilter)
          );
        } else {
          const selectedDateFirstMinute =
            moment(rangeStartDate).startOf("day").unix() * 1000;

          const selectedDateLastMinute =
            moment(rangeStartDate).endOf("day").unix() * 1000;
          taskBoardApiCall(
            authUser?.institute[0]?.instituteDetails?.id,
            selectedDateFirstMinute,
            selectedDateLastMinute,
            selectedUsersParam
              ? selectedUsersParam.split(",").filter(Boolean)
              : "",
            "",
            prioritiesArray,
            typesArray,
            Number(selectedDateFirstMinuteForFilter),
            Number(selectedDateLastMinuteForFilter)
          );
          taskCountCall(
            authUser?.institute[0]?.instituteDetails?.id,
            selectedDateFirstMinute,
            selectedDateLastMinute,
            selectedUsersParam
              ? selectedUsersParam.split(",").filter(Boolean)
              : "",
            "",
            prioritiesArray,
            typesArray,
            Number(selectedDateFirstMinuteForFilter),
            Number(selectedDateLastMinuteForFilter)
          );
        }
      }

      // const queryParams = new URLSearchParams();
      const queryParams = new URLSearchParams(window.location.search);
      if (prioritiesArray && prioritiesArray.length > 0) {
        const priorityParam = prioritiesArray
          .map((item: any) => item.priority)
          .join("|");
        queryParams.set("taskPriorities", priorityParam);
      } else {
        queryParams.delete("taskPriorities");
      }

      if (typesArray && typesArray.length > 0) {
        const statusParam = typesArray.map((item: any) => item.type).join("|");
        queryParams.set("taskTypes", statusParam);
      } else {
        queryParams.delete("taskTypes");
      }

      if (filterEndDates !== null && authUser) {
        queryParams.set(
          "taskFilterStartDate",
          selectedDateFirstMinuteForFilter.toString()
        );
        queryParams.set(
          "taskFilterEndDate",
          selectedDateLastMinuteForFilter.toString()
        );
      } else {
        queryParams.set(
          "taskFilterStartDate",
          selectedDateFirstMinuteForFilter.toString()
        );
        queryParams.set(
          "taskFilterEndDate",
          selectedStartDateLastMinuteForFilter.toString()
        );
      }
      if (filterStartDates === null && filterEndDates === null) {
        queryParams.delete("taskFilterStartDate");
        queryParams.delete("taskFilterEndDate");
      }
      const queryString = queryParams.toString();
      const newUrl = `${window.location.pathname}${
        queryString ? `?${queryString}` : ""
      }`;

      window.history.pushState({}, "", newUrl);
    },
    [
      setFilterCheckedPriorities,
      setFilterCheckedTypes,
      setFilterStartDate,
      setFilterEndDate,
    ]
  );

  const isTriggered = useSelector(
    (state: any) => state.taskBoardUpdation?.isTriggered
  );

  const taskBoardApiCall = useCallback(
    (
      instituteId: string,
      taskStartDate: any,
      taskEndDate: any,
      userId: any,
      searchText?: any,
      prioritiesArray?: any,
      typeArray?: any,
      startDateForFilter?: any,
      endDateForFilter?: any
    ) => {
      const data: any = {
        instituteId: instituteId,
        startDate: taskStartDate,
        endDate: taskEndDate,
        getTasks: true,
        entityName: "TASK",
        priority: prioritiesArray,
        taskType: typeArray,
        searchText: searchText ? searchText : "",
        lanesToFetch: [
          {
            status: "TO_DO",
          },
          {
            status: "IN_PROGRESS",
          },
          {
            status: "BLOCKED",
          },
          {
            status: "COMPLETED",
          },
        ],
        filterStartDate: startDateForFilter ? startDateForFilter : 0,
        filterEndDate: endDateForFilter ? endDateForFilter : 0,
      };

      if (!hasAllBranchAccess) {
        data.branchId = authUser?.institute?.[0]?.branchId;
      }

      if (hasAllTaskAccess && userId !== "") {
        data.userId = userId;
      } else if (!hasAllTaskAccess) {
        data.userId = authUser?.institute[0]?.id;
      }
      GetTasksBoard(data);
    },
    [userById, hasAllTaskAccess]
  );

  const taskCountCall = useCallback(
    (
      instituteId: string,
      taskStartDate: any,
      taskEndDate: any,
      userId: any,
      searchText?: any,
      prioritiesArray?: any,
      typeArray?: any,
      startDateForFilter?: any,
      endDateForFilter?: any
    ) => {
      const data: any = {
        instituteId: instituteId,
        startDate: taskStartDate,
        endDate: taskEndDate,
        getTasksCount: true,
        entityName: "TASK",
        priority: prioritiesArray,
        taskType: typeArray,
        searchText: searchText ? searchText : "",
        lanesToFetch: [
          {
            status: "TO_DO",
          },
          {
            status: "IN_PROGRESS",
          },
          {
            status: "BLOCKED",
          },
          {
            status: "COMPLETED",
          },
        ],
        filterStartDate: startDateForFilter ? startDateForFilter : 0,
        filterEndDate: endDateForFilter ? endDateForFilter : 0,
      };

      if (!hasAllBranchAccess) {
        data.branchId = authUser?.institute?.[0]?.branchId;
      }

      if (hasAllTaskAccess && userId !== "") {
        data.userId = userId;
      } else if (!hasAllTaskAccess) {
        data.userId = authUser?.institute[0]?.id;
      }
      GetTaskCount(data);
    },
    [userById, hasAllTaskAccess]
  );

  const [rangeStartDate, setRangeStartDate] = useState<any>(new Date());
  const [rangeEndDate, setRangeEndDate] = useState<any>(null);

  const onDateChange = (dates: any) => {
    const [start, end] = dates;
    setRangeStartDate(start);
    setRangeEndDate(end);
    const selectedDateFirstMinute = moment(start).startOf("day").unix() * 1000;
    const selectedStartDateLastMinute =
      moment(start).endOf("day").unix() * 1000;

    const selectedDateLastMinute = moment(end).endOf("day").unix() * 1000;

    const queryParams = new URLSearchParams(window.location.search);

    if (end !== null && authUser) {
      taskBoardApiCall(
        authUser?.institute[0]?.instituteDetails?.id,
        selectedDateFirstMinute,
        selectedDateLastMinute,
        selectedTeamMember?.length > 0 ? selectedTeamMember?.[0]?.id : ""
      );
      queryParams.set("taskStartDate", selectedDateFirstMinute.toString());
      queryParams.set("taskEndDate", selectedDateLastMinute.toString());

      const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
      window.history.pushState({}, "", newUrl);
    } else {
      taskBoardApiCall(
        authUser?.institute[0]?.instituteDetails?.id,
        selectedDateFirstMinute,
        selectedStartDateLastMinute,
        selectedTeamMember?.length > 0 ? selectedTeamMember?.[0]?.id : ""
      );
      queryParams.set("taskStartDate", selectedDateFirstMinute.toString());
      queryParams.set("taskEndDate", selectedStartDateLastMinute.toString());

      const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
      window.history.pushState({}, "", newUrl);
    }
  };

  const onFilterDateChange = (dates: any) => {
    const [start, end] = dates;
    setFilterStartDate(start);
    setFilterEndDate(end);
  };

  const handleResetDate = useCallback(() => {
    setSelectedDate(dayjs().unix() * 1000);
    setNewDate(dayjs());
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.delete("taskDate");
    queryParams.delete("taskStartDate");
    queryParams.delete("taskEndDate");

    const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
    window.history.pushState({}, "", newUrl);

    setRangeStartDate(new Date());
    setRangeEndDate(new Date());

    const selectedDateFirstMinute = moment().startOf("day").unix() * 1000;
    const selectedDateLastMinute = moment().endOf("day").unix() * 1000;

    taskBoardApiCall(
      authUser?.institute[0]?.instituteDetails?.id,
      selectedDateFirstMinute,
      selectedDateLastMinute,
      selectedTeamMember?.length > 0 ? selectedTeamMember?.[0]?.id : ""
    );
  }, [setSelectedDate, setRangeStartDate, setRangeEndDate, selectedTeamMember]);

  const handleNextPage = (currentLaneStatus: any) => {
    const userFromLocalStorage = authUser?.institute[0]?.instituteDetails;
    const urlSearchParams = new URLSearchParams(window.location.search);
    const taskStartDate = urlSearchParams.get("taskStartDate");
    const taskEndDate = urlSearchParams.get("taskEndDate");
    const selectedUsersParam = urlSearchParams.get("selectedUsers");

    let startingDate = null;
    let endingDate = null;
    if (taskStartDate && taskStartDate !== null && taskEndDate !== null) {
      startingDate = taskStartDate;
      endingDate = taskEndDate;
    } else {
      startingDate = moment(rangeStartDate).startOf("day").unix() * 1000;

      endingDate = moment(rangeStartDate).endOf("day").unix() * 1000;
    }

    const evaluatedKeysForLanes: any =
      taskItems &&
      taskItems
        ?.filter((d: any) => d?.stateName === currentLaneStatus)
        ?.map((d: any) => {
          return {
            status: currentLaneStatus,
            searchAfter: d?.tasks?.searchAfter,
          };
        });

    const data: any = {
      instituteId: userFromLocalStorage?.id,
      startDate: startingDate,
      endDate: endingDate,
      lanesToFetch: evaluatedKeysForLanes,
      getTasks: true,
      entityName: "TASK",
      priority: [],
      taskType: "",
      searchText: "",
    };

    if (!hasAllBranchAccess) {
      data.branchId = authUser?.institute?.[0]?.branchId;
    }

    if (hasAllTaskAccess && selectedUsersParam) {
      data.userId = selectedUsersParam.split(",").filter(Boolean);
    } else if (!hasAllTaskAccess) {
      data.userId = authUser?.institute[0]?.id;
    }

    GetTaskBoard(data).then((res: any) => {
      const result = res?.data?.data;
      const updatedState = taskItems?.map((oldObject: any) => {
        const correspondingResult = result?.find(
          (r: any) => r.stateName === oldObject.stateName
        );

        if (correspondingResult) {
          const updatedTasks = [...oldObject.tasks?.data];

          correspondingResult?.tasks?.data?.forEach((newTask: any) => {
            if (!updatedTasks?.find((task) => task.id === newTask.id)) {
              updatedTasks.push(newTask);
            }
          });

          return {
            ...oldObject,
            tasks: {
              data: updatedTasks,
              hasMore: correspondingResult?.tasks?.hasMore,
              searchAfter: correspondingResult?.tasks?.searchAfter,
            },
          };
        } else {
          return oldObject;
        }
      });
      setTaskItems(updatedState);
    });
  };

  useEffect(() => {
    if (tasks) {
      setTaskItems(tasks);
    } else {
      setTaskItems([]);
    }
  }, [tasks]);

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const taskDate = urlSearchParams.get("taskDate");
    const taskLeadSearchInUrl = urlSearchParams.get("taskLeadSearch");

    if (taskLeadSearchInUrl && taskLeadSearchInUrl !== "") {
      setLeadSearchTerm(taskLeadSearchInUrl);
    }

    if (taskDate && taskDate !== null) {
      setSelectedDate(parseInt(taskDate));
    }
  }, [setSelectedDate, setLeadSearchTerm]);

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);

    const priorityParam = urlSearchParams.get("taskPriorities");
    const typeParam = urlSearchParams.get("taskTypes");

    let selectedPriorities;
    let selectedTypes;

    if (priorityParam) {
      const priorities = priorityParam.split("|");

      selectedPriorities = priorities
        .map((value) => {
          const priority = [
            { priority: "URGENT" },
            { priority: "HIGH" },
            { priority: "NORMAL" },
            { priority: "LOW" },
          ].find(
            (type: any) => type.priority.toLowerCase() === value.toLowerCase()
          );
          return priority
            ? {
                priority: priority.priority,
              }
            : null;
        })
        .filter(Boolean) as CheckedPriorities[];

      setFilterCheckedPriorities(selectedPriorities);
    }

    if (typeParam && tasksTypes) {
      const types = typeParam.split("|");

      selectedTypes = types
        .map((value) => {
          const type = tasksTypes?.find(
            (taskType: any) =>
              taskType.taskTypeName.toLowerCase() === value.toLowerCase()
          );
          return type
            ? {
                type: type.taskTypeName,
              }
            : null;
        })
        .filter(Boolean) as CheckedTypes[];

      setFilterCheckedTypes(selectedTypes);
    }
  }, [tasksTypes]);

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const taskStartDate = urlSearchParams.get("taskStartDate");
    const taskEndDate = urlSearchParams.get("taskEndDate");
    const selectedUsersParam = urlSearchParams.get("selectedUsers");
    const taskFilterStartDate: any = urlSearchParams.get("taskFilterStartDate");
    const taskFilterEndDate: any = urlSearchParams.get("taskFilterEndDate");

    const priorityParam = urlSearchParams.get("taskPriorities");
    const typeParam = urlSearchParams.get("taskTypes");

    let selectedPriorities;
    let selectedTypes;

    if (priorityParam) {
      const priorities = priorityParam.split("|");

      selectedPriorities = priorities
        .map((value) => {
          const priority = [
            { priority: "URGENT" },
            { priority: "HIGH" },
            { priority: "NORMAL" },
            { priority: "LOW" },
          ].find(
            (type: any) => type.priority.toLowerCase() === value.toLowerCase()
          );
          return priority
            ? {
                priority: priority.priority,
              }
            : null;
        })
        .filter(Boolean) as CheckedPriorities[];
    }

    if (typeParam && tasksTypes) {
      const types = typeParam.split("|");

      selectedTypes = types
        .map((value) => {
          const type = tasksTypes?.find(
            (taskType: any) =>
              taskType.taskTypeName.toLowerCase() === value.toLowerCase()
          );
          return type
            ? {
                type: type.taskTypeName,
              }
            : null;
        })
        .filter(Boolean) as CheckedTypes[];
    }

    if (userById) {
      if (taskStartDate && taskStartDate !== null && taskEndDate !== null) {
        const startDate = new Date(parseInt(taskStartDate));
        const endDate = new Date(parseInt(taskEndDate));

        setRangeStartDate(startDate);
        setRangeEndDate(endDate);
        console.log(1);

        taskBoardApiCall(
          authUser?.institute[0]?.instituteDetails?.id,
          taskStartDate,
          taskEndDate,
          selectedUsersParam
            ? selectedUsersParam.split(",").filter(Boolean)
            : "",
          "",
          selectedPriorities,
          selectedTypes,
          Number(taskFilterStartDate),
          Number(taskFilterEndDate)
        );
        taskCountCall(
          authUser?.institute[0]?.instituteDetails?.id,
          taskStartDate,
          taskEndDate,
          selectedUsersParam
            ? selectedUsersParam.split(",").filter(Boolean)
            : "",
          "",
          selectedPriorities,
          selectedTypes,
          Number(taskFilterStartDate),
          Number(taskFilterEndDate)
        );
      } else {
        const selectedDateFirstMinute =
          moment(rangeStartDate).startOf("day").unix() * 1000;

        const selectedDateLastMinute =
          moment(rangeStartDate).endOf("day").unix() * 1000;
        console.log(2);

        taskBoardApiCall(
          authUser?.institute[0]?.instituteDetails?.id,
          selectedDateFirstMinute,
          selectedDateLastMinute,
          selectedUsersParam
            ? selectedUsersParam.split(",").filter(Boolean)
            : "",
          "",
          selectedPriorities,
          selectedTypes,
          Number(taskFilterStartDate),
          Number(taskFilterEndDate)
        );
        taskCountCall(
          authUser?.institute[0]?.instituteDetails?.id,
          selectedDateFirstMinute,
          selectedDateLastMinute,
          selectedUsersParam
            ? selectedUsersParam.split(",").filter(Boolean)
            : "",
          "",
          selectedPriorities,
          selectedTypes,
          Number(taskFilterStartDate),
          Number(taskFilterEndDate)
        );
      }
    }
  }, [userById]);

  const { createPaymentSuccessForTask } = useSelector(
    (state: any) => state?.nurture
  );

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const taskStartDate = urlSearchParams.get("taskStartDate");
    const taskEndDate = urlSearchParams.get("taskEndDate");
    const selectedUsersParam = urlSearchParams.get("selectedUsers");
    const taskFilterStartDate = urlSearchParams.get("taskFilterStartDate");
    const taskFilterEndDate = urlSearchParams.get("taskFilterEndDate");
    setTimeout(() => {
      if (rangeStartDate && authUser && authUser.institute) {
        if (taskStatusUpdateSuccess) {
          if (taskStartDate && taskEndDate) {
            console.log(3);

            taskBoardApiCall(
              authUser?.institute[0]?.instituteDetails?.id,
              taskStartDate,
              taskEndDate,
              selectedUsersParam
                ? selectedUsersParam.split(",").filter(Boolean)
                : "",
              "",
              filterCheckedPriorities,
              filterCheckedTypes,
              Number(taskFilterStartDate),
              Number(taskFilterEndDate)
            );
            taskCountCall(
              authUser?.institute[0]?.instituteDetails?.id,
              taskStartDate,
              taskEndDate,
              selectedUsersParam
                ? selectedUsersParam.split(",").filter(Boolean)
                : "",
              "",
              filterCheckedPriorities,
              filterCheckedTypes,
              Number(taskFilterStartDate),
              Number(taskFilterEndDate)
            );
          } else {
            const selectedDateFirstMinute =
              moment(rangeStartDate).startOf("day").unix() * 1000;

            const selectedDateLastMinute =
              moment(rangeStartDate).endOf("day").unix() * 1000;
            console.log(4);

            taskBoardApiCall(
              authUser?.institute[0]?.instituteDetails?.id,
              selectedDateFirstMinute,
              selectedDateLastMinute,
              selectedUsersParam
                ? selectedUsersParam.split(",").filter(Boolean)
                : "",
              "",
              filterCheckedPriorities,
              filterCheckedTypes,
              Number(taskFilterStartDate),
              Number(taskFilterEndDate)
            );
            taskCountCall(
              authUser?.institute[0]?.instituteDetails?.id,
              selectedDateFirstMinute,
              selectedDateLastMinute,
              selectedUsersParam
                ? selectedUsersParam.split(",").filter(Boolean)
                : "",
              "",
              filterCheckedPriorities,
              filterCheckedTypes,
              Number(taskFilterStartDate),
              Number(taskFilterEndDate)
            );
          }
        }
      }
    }, 1000);
  }, [taskStatusUpdateSuccess]);

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const taskStartDate = urlSearchParams.get("taskStartDate");
    const taskEndDate = urlSearchParams.get("taskEndDate");
    const selectedUsersParam = urlSearchParams.get("selectedUsers");
    const taskFilterStartDate = urlSearchParams.get("taskFilterStartDate");
    const taskFilterEndDate = urlSearchParams.get("taskFilterEndDate");
    if (
      createPaymentSuccessForTask !== true &&
      createPaymentSuccessForTask !== false
    ) {
      if (rangeStartDate && authUser && authUser.institute) {
        setTimeout(() => {
          if (rangeStartDate && authUser && authUser.institute) {
            if (taskStartDate && taskEndDate) {
              console.log(5);

              taskBoardApiCall(
                authUser?.institute[0]?.instituteDetails?.id,
                taskStartDate,
                taskEndDate,
                selectedUsersParam
                  ? selectedUsersParam.split(",").filter(Boolean)
                  : "",
                "",
                filterCheckedPriorities,
                filterCheckedTypes,
                Number(taskFilterStartDate),
                Number(taskFilterEndDate)
              );
              taskCountCall(
                authUser?.institute[0]?.instituteDetails?.id,
                taskStartDate,
                taskEndDate,
                selectedUsersParam
                  ? selectedUsersParam.split(",").filter(Boolean)
                  : "",
                "",
                filterCheckedPriorities,
                filterCheckedTypes,
                Number(taskFilterStartDate),
                Number(taskFilterEndDate)
              );
            } else {
              const selectedDateFirstMinute =
                moment(rangeStartDate).startOf("day").unix() * 1000;

              const selectedDateLastMinute =
                moment(rangeStartDate).endOf("day").unix() * 1000;
              console.log(6);

              taskBoardApiCall(
                authUser?.institute[0]?.instituteDetails?.id,
                selectedDateFirstMinute,
                selectedDateLastMinute,
                selectedUsersParam
                  ? selectedUsersParam.split(",").filter(Boolean)
                  : "",
                "",
                filterCheckedPriorities,
                filterCheckedTypes,
                Number(taskFilterStartDate),
                Number(taskFilterEndDate)
              );
              taskCountCall(
                authUser?.institute[0]?.instituteDetails?.id,
                selectedDateFirstMinute,
                selectedDateLastMinute,
                selectedUsersParam
                  ? selectedUsersParam.split(",").filter(Boolean)
                  : "",
                "",
                filterCheckedPriorities,
                filterCheckedTypes,
                Number(taskFilterStartDate),
                Number(taskFilterEndDate)
              );
            }
          }
          dispatch(resetCreatePaymentSuccessForTask());
        }, 1000);
      }
    }
  }, [createPaymentSuccessForTask]);

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const taskStartDate = urlSearchParams.get("taskStartDate");
    const taskEndDate = urlSearchParams.get("taskEndDate");
    const selectedUsersParam = urlSearchParams.get("selectedUsers");
    const taskFilterStartDate = urlSearchParams.get("taskFilterStartDate");
    const taskFilterEndDate = urlSearchParams.get("taskFilterEndDate");
    if (rangeStartDate && authUser) {
      if (
        (editTaskSuccess !== true && editTaskSuccess !== false) ||
        (createTaskSuccess !== true && createTaskSuccess !== false) ||
        (deleteTaskSuccess !== true && deleteTaskSuccess !== false) ||
        (leadUpdateSuccess !== true && leadUpdateSuccess !== false)
      ) {
        if (taskStartDate && taskEndDate) {
          console.log(7);

          taskBoardApiCall(
            authUser?.institute[0]?.instituteDetails?.id,
            taskStartDate,
            taskEndDate,
            selectedUsersParam
              ? selectedUsersParam.split(",").filter(Boolean)
              : "",
            "",
            filterCheckedPriorities,
            filterCheckedTypes,
            Number(taskFilterStartDate),
            Number(taskFilterEndDate)
          );
          taskCountCall(
            authUser?.institute[0]?.instituteDetails?.id,
            taskStartDate,
            taskEndDate,
            selectedUsersParam
              ? selectedUsersParam.split(",").filter(Boolean)
              : "",
            "",
            filterCheckedPriorities,
            filterCheckedTypes,
            Number(taskFilterStartDate),
            Number(taskFilterEndDate)
          );
        } else {
          const selectedDateFirstMinute =
            moment(rangeStartDate).startOf("day").unix() * 1000;

          const selectedDateLastMinute =
            moment(rangeStartDate).endOf("day").unix() * 1000;
          console.log(8);

          taskBoardApiCall(
            authUser?.institute[0]?.instituteDetails?.id,
            selectedDateFirstMinute,
            selectedDateLastMinute,
            selectedUsersParam
              ? selectedUsersParam.split(",").filter(Boolean)
              : "",
            "",
            filterCheckedPriorities,
            filterCheckedTypes,
            Number(taskFilterStartDate),
            Number(taskFilterEndDate)
          );
          taskCountCall(
            authUser?.institute[0]?.instituteDetails?.id,
            selectedDateFirstMinute,
            selectedDateLastMinute,
            selectedUsersParam
              ? selectedUsersParam.split(",").filter(Boolean)
              : "",
            "",
            filterCheckedPriorities,
            filterCheckedTypes,
            Number(taskFilterStartDate),
            Number(taskFilterEndDate)
          );
        }
      }
    }
  }, [
    createTaskSuccess,
    editTaskSuccess,
    deleteTaskSuccess,
    leadUpdateSuccess,
  ]);

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const selectedUsersParam = urlSearchParams.get("selectedUsers");
    // if (employees?.length > 0) {
    //   const staff = employees
    //     ?.filter((item: any) => item?.status === "ACTIVE")
    //     ?.find((item: any) => item.id === selectedUsersParam);
    //   if (staff) {
    //     setSelectedTeamMember([staff]);
    //   } else {
    //     setSelectedTeamMember([]);
    //   }
    // }

    const selectedUserIds: string[] = selectedUsersParam
      ? selectedUsersParam.split(",").filter(Boolean)
      : [];

    if (selectedUserIds.length > 0) {
      const preselectedMembers =
        employees &&
        employees?.filter((member: any) =>
          selectedUserIds.includes(String(member.id))
        );
      setSelectedTeamMember(preselectedMembers);
    }
  }, [employees]);

  React.useEffect(() => {
    if (Array.isArray(taskItems)) {
      const evaluatedKeysForLanes = taskItems?.map((d) => {
        return {
          status: d?.status,
          lastEvaluatedKey: d?.lastEvaluatedKey ? d?.lastEvaluatedKey : "",
          lastEvaluatedSortKey: d?.lastEvaluatedSortKey
            ? d?.lastEvaluatedSortKey
            : "",
        };
      });

      const hasEvaluatedKey = evaluatedKeysForLanes.some(
        (ds) => ds.lastEvaluatedKey !== ""
      );

      setHasMoreData(hasEvaluatedKey);
    } else {
      setHasMoreData(false);
    }
  }, [taskItems]);

  const handlePopupYesButton = () => {
    handleSendRemainders();
  };

  const handlePopupNoButton = () => {
    setIsOpen(false);
  };

  const handleSendRemainders = (id?: any, type?: string) => {
    var body;
    const userFromLocalStorage = authUser?.institute[0]?.instituteDetails;
    if (cardType === "GLOBAL") {
      body = {
        action: "sendReminder",
        instituteId: userFromLocalStorage?.id,
        type: "GLOBAL",
        branchId:
          userById?.roleCode === "SUPER_ADMIN"
            ? ""
            : authUser?.institute?.[0]?.branchId,
        triggeredById: authUser?.institute[0]?.id,
      };
    } else if (cardType === "STAGE") {
      body = {
        action: "sendReminder",
        instituteId: userFromLocalStorage?.id,
        type: "STAGE",
        branchId:
          userById?.roleCode === "SUPER_ADMIN"
            ? ""
            : authUser?.institute?.[0]?.branchId,
        stageName: stateName,
        triggeredById: authUser?.institute[0]?.id,
      };
    } else if (type === "CARD") {
      body = {
        action: "sendReminder",
        instituteId: userFromLocalStorage?.id,
        type: "INDIVIDUAL",
        taskId: id,
        triggeredById: authUser?.institute[0]?.id,
      };
    }
    SendRemainders(body);
    setCardType("");
    setStateName("");
    setTaskId("");
  };

  useEffect(() => {
    if (sendRemaindersSuccess) {
      dispatch(resetSendRemainders());
      setIsOpen(false);
    }
  }, [sendRemaindersSuccess]);

  return (
    <Box sx={{ backgroundColor: "#F5F5F5", display: "flex", width: "100%" }}>
      <Box className={styles.taskKanbanBoard}>
        <TaskKanbanHeader
          handleFilterTasks={handleFilterTasks}
          handleLeadSearch={handleLeadSearch}
          leadSearchTerm={leadSearchTerm}
          tasksTypes={tasksTypes}
          filteredValue={filteredValue}
          filterCheckedPriorities={filterCheckedPriorities}
          filterCheckedTypes={filterCheckedTypes}
          setSelectedTeamMember={setSelectedTeamMember}
          selectedTeamMember={selectedTeamMember}
          rangeStartDate={rangeStartDate}
          taskBoardApiCall={taskBoardApiCall}
          setIsOpen={setIsOpen}
          filterStartDate={filterStartDate}
          setFilterStartDate={setFilterStartDate}
          filterEndDate={filterEndDate}
          setFilterEndDate={setFilterEndDate}
          onFilterDateChange={onFilterDateChange}
          setCardType={setCardType}
          setTextForReminder={setTextForReminder}
          taskCountCall={taskCountCall}
        />
        <div
          style={{
            padding: "16px 11px 0px 11px",
            overflowX: "auto",
            position: "relative",
          }}
        >
          {tasks && allTasksEmpty === true && draggedColumn === "" ? (
            <div
              style={{
                position: "absolute",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#667085",
                  textTransform: "capitalize",
                }}
              >
                No data available
              </div>
            </div>
          ) : (
            <></>
          )}

          <div
            style={{
              overflowX: "auto",
              overflowY: "hidden",
              minHeight: "calc(100vh - 127px)",
              minWidth: "max-content",
            }}
          >
            <div className={styles.kanbanBoard}>
              {taskBoardloading === false ? (
                <>
                  {tasks &&
                    filteredTasks?.map((column: any) => (
                      <div key={column.id} className={styles.kanbanColumn}>
                        <div className={styles.kanbanColumnHead}>
                          <div className={styles.kanbanColumnHeadTitle}>
                            {column?.stateName
                              ?.toLowerCase()
                              ?.replace(/_/g, " ")}
                          </div>

                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                          >
                            {(userById?.roleCode === "SUPER_ADMIN" ||
                              userById?.roleCode === "ADMIN") &&
                              taskCountLength?.data?.filter(
                                (task: any) =>
                                  task?.stateName === column.stateName
                              )?.[0]?.tasksCount > 0 && (
                                <img
                                  src={Remainder}
                                  onClick={() => {
                                    setIsOpen(true);
                                    setStateName(column?.stateName);
                                    setCardType("STAGE");
                                    setTextForReminder(
                                      `You have few task pending in ${
                                        column?.stateName === "TO_DO"
                                          ? "To Do"
                                          : column?.stateName === "IN_PROGRESS"
                                          ? "In Progress"
                                          : "Blocked"
                                      } stage. Please complete it soon.`
                                    );
                                  }}
                                />
                              )}
                            <div className={styles.kanbanColumnHeadCount}>
                              {
                                // ?.filter((task: any) => {
                                //   if (leadSearchTerm === "") {
                                //     return true;
                                //   }
                                //   const fullName = task.studentName;
                                //   return fullName
                                //     .toLowerCase()
                                //     .includes(leadSearchTerm.toLowerCase());
                                // })
                                // ?.filter((task: any) => {
                                //   if (filterCheckedPriorities.length === 0) {
                                //     return true;
                                //   }
                                //   return filterCheckedPriorities.some(
                                //     (item) =>
                                //       task.priority.toLowerCase() ===
                                //       item.priority.toLowerCase()
                                //   );
                                // })
                                // ?.filter((task: any) => {
                                //   if (filterCheckedTypes.length === 0) {
                                //     return true;
                                //   }
                                //   return filterCheckedTypes.some(
                                //     (item) => task.taskType === item.type
                                //   );
                                // })
                                taskCountLength?.data?.filter(
                                  (task: any) =>
                                    task?.stateName === column.stateName
                                )?.[0]?.tasksCount
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </>
              ) : (
                Array.from(new Array(3)).map((_, index) => (
                  <div
                    key={index}
                    className={styles.kanbanColumn}
                    style={{ marginBottom: "8px" }}
                  >
                    <div className={styles.kanbanColumnHead}>
                      <Skeleton
                        animation="wave"
                        variant="text"
                        width={210}
                        height={25}
                      />
                    </div>
                  </div>
                ))
              )}
            </div>
            <div
              className={styles.kanbanBoardLeadsWrap}
              style={{
                maxHeight: `calc(100vh - 206px)`,
                overflowY: "auto",
                minHeight: `calc(78vh - 45.6px)`,
                overflowX: "hidden",
                minWidth: "max-content",
              }}
            >
              {taskBoardloading === false ? (
                <>
                  {tasks &&
                    filteredTasks?.map((column: any) => (
                      <div
                        key={column.id}
                        className={styles.kanbanColumnLeads}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={(event) =>
                          handleDrop(event, column.stateName, column.stateName)
                        }
                      >
                        {dropZoneActive ? (
                          <div className={styles.dropZoneBox}></div>
                        ) : (
                          <InfiniteScroll
                            dataLength={column?.tasks?.data?.length}
                            next={() => handleNextPage(column.stateName)}
                            hasMore={column?.tasks?.hasMore}
                            loader={
                              <Box
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {
                                  // <PuffLoader color="#36d7b7" />
                                }
                              </Box>
                            }
                            height={1400}
                          >
                            <div className={styles.kanbanColumnTasks}>
                              {column?.tasks?.data
                                ?.filter(
                                  (task: any) =>
                                    task?.status === column.stateName
                                )
                                // ?.filter((task: any) => {
                                //   if (leadSearchTerm === "") {
                                //     return true;
                                //   }
                                //   const fullName = task.studentName;
                                //   const isDemoTask = task.taskType === "DEMO";

                                //   if (isDemoTask) {
                                //     const batchName =
                                //       task?.demoData?.[0]?.batchName;
                                //     return batchName
                                //       ? batchName
                                //           .toLowerCase()
                                //           .includes(
                                //             leadSearchTerm.toLowerCase()
                                //           )
                                //       : false;
                                //   }

                                //   return fullName
                                //     .toLowerCase()
                                //     .includes(leadSearchTerm.toLowerCase());
                                // })
                                // ?.filter((task: any) => {
                                //   if (filterCheckedPriorities.length === 0) {
                                //     return true;
                                //   }
                                //   return filterCheckedPriorities.some(
                                //     (item) =>
                                //       task.priority.toLowerCase() ===
                                //       item.priority.toLowerCase()
                                //   );
                                // })
                                // ?.filter((task: any) => {
                                //   if (filterCheckedTypes.length === 0) {
                                //     return true;
                                //   }
                                //   return filterCheckedTypes.some(
                                //     (item) => task.taskType === item.type
                                //   );
                                // })
                                ?.map((task: any) => (
                                  <div
                                    key={task.id}
                                    className={styles.kanbanTask}
                                    draggable
                                    onDragStart={(event) =>
                                      handleDragStart(
                                        event,
                                        column.stateName,
                                        task.id,
                                        task.taskType,
                                        task
                                      )
                                    }
                                  >
                                    <div className={styles.taskType}>
                                      <div
                                        className={styles.dateSelect}
                                        style={{
                                          color:
                                            moment(task?.date) < moment()
                                              ? "red"
                                              : "inherit",
                                        }}
                                      >
                                        {getFormattedDate(task?.date)}
                                      </div>
                                      <div className={styles.taskFlag}>
                                        <div className={styles.taskTypeSelect}>
                                          {task.taskType?.toLowerCase()}
                                        </div>
                                        <div className={styles.userCircle}>
                                          {getTeamMember(
                                            task?.assignedToId,
                                            employees
                                          )?.firstName === undefined
                                            ? ""
                                            : getTeamMember(
                                                task?.assignedToId,
                                                employees
                                              )?.firstName?.charAt(0) +
                                              "" +
                                              getTeamMember(
                                                task?.assignedToId,
                                                employees
                                              )?.lastName?.charAt(0)}
                                        </div>
                                        <div className={styles.flagAssign}>
                                          {task.priority === "HIGH" && (
                                            <img src={High} alt="High" />
                                          )}
                                          {task.priority === "NORMAL" && (
                                            <img src={Normal} alt="Normal" />
                                          )}
                                          {task.priority === "LOW" && (
                                            <img src={Low} alt="Low" />
                                          )}
                                          {task.priority === "URGENT" && (
                                            <img src={Urgent} alt="Urgent" />
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className={styles.lead}
                                      onClick={() =>
                                        task.taskType === "DEMO"
                                          ? navigate(
                                              `/app/Tasks/DemoTaskDetails/${task.id}`
                                            )
                                          : hasLeadCardPermission
                                          ? !hasAllBranchAccess &&
                                            userById?.branchId !==
                                              task?.branchId
                                            ? dispatch(
                                                setToastNotification({
                                                  message: String(
                                                    "You do not have all branches access and this lead belongs to different a branch"
                                                  ),
                                                  type: "error",
                                                  snackOpen: true,
                                                })
                                              )
                                            : openLeadExpandModal(
                                                task?.instituteId
                                                  ? task?.instituteId
                                                  : task?.enquiryData
                                                      ?.instituteId,
                                                task?.studentContact
                                                  ? task?.studentContact
                                                  : task?.enquiryData
                                                      ?.studentContact,
                                                task?.studentEmail
                                                  ? task?.studentEmail
                                                  : task?.enquiryData
                                                      ?.studentEmail,
                                                task?.enquiryId,
                                                dispatch,
                                                "task",
                                                task.id,
                                                "INCOMPLETE"
                                              )
                                          : dispatch(
                                              setToastNotification({
                                                message: String(
                                                  "You do not have permission to access the lead card"
                                                ),
                                                type: "error",
                                                snackOpen: true,
                                              })
                                            )
                                      }
                                    >
                                      {task?.taskType === "DEMO" ? (
                                        <>{task?.demoData?.[0]?.batchName}</>
                                      ) : (
                                        <>{task.studentName}</>
                                      )}
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {task?.taskType === "DEMO" ? (
                                        <>
                                          <div
                                            className={styles.taskTitle}
                                            style={{
                                              display: "flex",
                                              gap: "2px",
                                            }}
                                          >
                                            <div
                                              className={
                                                styles.taskDemoItemLabel
                                              }
                                            >
                                              Time:
                                            </div>
                                            <div
                                              className={
                                                styles.taskDemoItemValue
                                              }
                                            >
                                              {moment(
                                                task?.demoData?.[0]
                                                  ?.demoStartTime
                                              ).format(" hh:mm A") +
                                                " to " +
                                                moment(
                                                  task?.demoData?.[0]
                                                    ?.demoEndTime
                                                ).format(" hh:mm A")}
                                            </div>
                                          </div>
                                          <div
                                            className={styles.taskTitle}
                                            style={{
                                              display: "flex",
                                              gap: "2px",
                                            }}
                                          >
                                            <div>Course:</div>
                                            <div>
                                              {task?.enquiryData?.courseName}
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        <div
                                          className={styles.taskDesc}
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              getDescriptionWithMentionedNames(
                                                task?.description,
                                                employees
                                              ).replace(/\n/g, "<br>"),
                                          }}
                                        ></div>
                                      )}
                                      {(userById?.roleCode === "SUPER_ADMIN" ||
                                        userById?.roleCode === "ADMIN") && (
                                        <img
                                          src={Remainder}
                                          onClick={() => {
                                            // setIsOpen(true);
                                            handleSendRemainders(
                                              task?.id,
                                              "CARD"
                                            );
                                            setTaskId(task?.id);
                                            setCardType("CARD");
                                            setTextForReminder(
                                              "Do you want to send bulk reminders for the task?"
                                            );
                                          }}
                                        />
                                      )}
                                    </div>
                                  </div>
                                ))}
                            </div>
                          </InfiniteScroll>
                        )}
                      </div>
                    ))}
                </>
              ) : (
                Array.from(new Array(3)).map((_, index) => (
                  <div key={index} className={styles.kanbanColumn}>
                    <div className={styles.kanbanColumnTasks}>
                      <Skeleton
                        animation="wave"
                        variant="rectangular"
                        height="60vh"
                        style={{
                          marginBottom: "10px",
                          borderRadius: "3px",
                        }}
                      />
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </Box>
      <Box
        sx={{
          background: "#fff",
          width: "360px",
          borderLeft: "1px solid #E9E9E9",
        }}
        className="datepicker-container"
      >
        {taskBoardloading === false ? (
          <>
            <DateRangePicker
              startDate={rangeStartDate}
              endDate={rangeEndDate}
              onDateChange={onDateChange}
              minDate={moment().toDate()}
            />

            {rangeEndDate &&
              moment(rangeEndDate).startOf("day").unix() * 1000 >
                moment().startOf("day").unix() * 1000 && (
                <div
                  style={{
                    padding: "0 20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    marginBottom: "20px",
                  }}
                >
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={handleResetDate}
                    sx={{
                      textTransform: "capitalize",
                      fontSize: "12px",
                      fontWeight: "500",
                    }}
                    size="small"
                  >
                    Reset Date
                  </Button>
                </div>
              )}
          </>
        ) : (
          <>
            <div style={{ padding: "10px" }}>
              <Skeleton
                animation="wave"
                variant="rectangular"
                height="40px"
                style={{
                  borderRadius: "3px",
                  marginBottom: "10px",
                }}
              />
              <Skeleton
                animation="wave"
                variant="rectangular"
                height="290px"
                style={{
                  borderRadius: "3px",
                }}
              />
            </div>
          </>
        )}

        <div style={{ padding: "0px 20px 20px 20px" }}>
          {taskBoardloading === false ? (
            <>
              <div className={styles.taskCompletedWrap}>
                <div className={styles.taskCompletedWrapHead}>Completed</div>
                <div
                  className={styles.taskCompletedWrapViewAll}
                  onClick={() =>
                    navigate(
                      selectedTeamMember?.length > 0
                        ? `/app/Tasks/TaskCompleted?selectedUsers=${selectedTeamMember[0]?.id}`
                        : `/app/Tasks/TaskCompleted`,
                      { state: { taskSelectedId: selectedTeamMember[0]?.id } }
                    )
                  }
                >
                  View all
                </div>
              </div>
              <div
                className={styles.taskCompletedListWrap}
                onDragOver={handleDragOver}
                // onDragLeave={handleDragLeave}
                onDrop={(event) => handleCompletedDrop(event)}
                style={{
                  position: "relative",
                  maxHeight:
                    rangeEndDate &&
                    moment(rangeEndDate).startOf("day").unix() * 1000 >
                      moment().startOf("day").unix() * 1000
                      ? "calc(100vh - 460px)"
                      : "calc(100vh - 440px) ",
                  minHeight:
                    rangeEndDate &&
                    moment(rangeEndDate).startOf("day").unix() * 1000 >
                      moment().startOf("day").unix() * 1000
                      ? "calc(100vh - 460px)"
                      : "calc(100vh - 440px)",
                }}
              >
                {dropZoneActive ? (
                  <div
                    style={{
                      border: "2px dashed #11c89b",
                      width: "100%",
                      maxHeight:
                        rangeEndDate &&
                        moment(rangeEndDate).startOf("day").unix() * 1000 >
                          moment().startOf("day").unix() * 1000
                          ? "calc(100vh - 480px)"
                          : "calc(100vh - 460px) ",
                      minHeight:
                        rangeEndDate &&
                        moment(rangeEndDate).startOf("day").unix() * 1000 >
                          moment().startOf("day").unix() * 1000
                          ? "calc(100vh - 480px)"
                          : "calc(100vh - 460px)",
                    }}
                  ></div>
                ) : (
                  <>
                    {tasksByAssignee &&
                      completedTasks &&
                      completedTasksEmpty === true && (
                        <div
                          style={{
                            position: "absolute",
                            top: "0",
                            left: "0",
                            right: "0",
                            bottom: "0",
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                            justifyContent: "center",
                          }}
                        >
                          <div
                            style={{
                              fontSize: "14px",
                              textAlign: "center",
                              color: "#667085",
                              fontWeight: "600",
                              marginBottom: "6PX",
                            }}
                          >
                            No data available
                          </div>
                          <div
                            style={{
                              fontSize: "13px",
                              textAlign: "center",
                              color: "#667085",
                            }}
                          >
                            Drag and drop the completed task after completion
                          </div>
                        </div>
                      )}
                    {tasks && completedTasks && (
                      <InfiniteScroll
                        dataLength={completedTasks?.tasks?.data?.length}
                        next={() => handleNextPage(completedTasks?.stateName)}
                        hasMore={completedTasks?.tasks?.hasMore}
                        loader={
                          <Box
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {
                              // <PuffLoader color="#36d7b7" />
                            }
                          </Box>
                        }
                        height={
                          rangeEndDate &&
                          moment(rangeEndDate).startOf("day").unix() * 1000 >
                            moment().startOf("day").unix() * 1000
                            ? "calc(100vh - 460px)"
                            : "calc(100vh - 440px)"
                        }
                      >
                        {tasks &&
                          completedTasks?.tasks?.data?.map((task: any) => (
                            <CompletedCard
                              taskCompletedPage={false}
                              task={task}
                              expandDisabled={false}
                              employees={employees}
                              page="TASK_BOARD"
                              handleDragStart={handleDragStart}
                            />
                          ))}
                      </InfiniteScroll>
                    )}
                  </>
                )}
              </div>
            </>
          ) : (
            <>
              {Array.from(new Array(4)).map((_, index) => (
                <div key={index} className={styles.tableSkeletonBodyItem}>
                  <Skeleton
                    animation="wave"
                    variant="rounded"
                    width="100%"
                    height={50}
                  />
                </div>
              ))}
            </>
          )}
        </div>
      </Box>
      <RemainderPopup
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        handlePopupYesButton={handlePopupYesButton}
        handlePopupNoButton={handlePopupNoButton}
        loading={sendRemaindersLoading}
        textForReminder={textForReminder}
      />
    </Box>
  );
}
